import Button from '@blaze-react/button';
import PropTypes from 'prop-types';
import { useState } from 'react';
import FormInText from './FormInText';
import FullPageForm from './FullPageForm';
import SignupForm from './SignupForm';

const BUTTON_TYPES = {
  MOBILE_STICKY: 'mobile-sticky',
  DESKTOP_BODY_MODAL: 'desktop-body-modal',
  DESKTOP_SIDEBAR: 'desktop-sidebar',
  REGULAR: 'regular'
};

const NewsletterSignup = ({
  productBriefing,
  productBusinessNews,
  productDeepDive,
  productEvents,
  productMarketing,
  productPodcast,
  embed,
  title,
  toastCaption: toastCaptionSetting,
  salesForceCampaignId,
  buttonTitle,
  buttonType,
  children
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toastCaption = toastCaptionSetting || 'Newsletter subscription sent successfully';

  let product;
  if (productBriefing) {
    product = 'briefing';
  }
  if (productBusinessNews) {
    product = 'businessNews';
  }
  if (productDeepDive) {
    product = 'deepDive';
  }
  if (productEvents) {
    product = 'events';
  }
  if (productMarketing) {
    product = 'marketing';
  }
  if (productPodcast) {
    product = 'podcast';
  }

  if (embed === 'true') {
    return (
      <SignupForm
        productBriefing={productBriefing}
        productBusinessNews={productBusinessNews}
        productDeepDive={productDeepDive}
        productEvents={productEvents}
        productMarketing={productMarketing}
        productPodcast={productPodcast}
        title={title}
        toastCaption={toastCaption}
        salesForceCampaignId={salesForceCampaignId}
        embedded
        closeModal={() => {}}>
        {children}
      </SignupForm>
    );
  }

  if (embed === 'full-page') {
    return (
      <FullPageForm
        productBriefing={productBriefing}
        productBusinessNews={productBusinessNews}
        productDeepDive={productDeepDive}
        productEvents={productEvents}
        productMarketing={productMarketing}
        productPodcast={productPodcast}
        subtitle={buttonTitle}
        toastCaption={toastCaption}
        salesForceCampaignId={salesForceCampaignId}
        title={title}
      />
    );
  }

  if (embed === 'repeat') {
    return (
      <FormInText
        product={product}
        title={title}
        subtitle={buttonTitle}
        toastCaption={toastCaption}
        salesForceCampaignId={salesForceCampaignId}>
        {children}
      </FormInText>
    );
  }

  const openNotOnMobile = () => {
    if (buttonType === BUTTON_TYPES.DESKTOP_SIDEBAR) {
      return;
    }

    setModalOpen(true);
  };

  return (
    <>
      {buttonType === BUTTON_TYPES.MOBILE_STICKY && !modalOpen && (
        <div className="newsletter-signup__button-sticky-wrapper">
          <Button
            className="newsletter-signup__button newsletter-signup__button--type-mobile-sticky"
            title="Subscribe to Newsletters"
            onClick={() => setModalOpen(true)}>
            {buttonTitle}
          </Button>
        </div>
      )}

      {buttonType !== BUTTON_TYPES.MOBILE_STICKY && (
        <Button
          className={`${buttonType === BUTTON_TYPES.REGULAR ? 'button button--cta button--center' : `newsletter-signup__button newsletter-signup__button--type-${buttonType}`}`}
          title="Subscribe to Newsletters"
          onClick={openNotOnMobile}>
          {buttonTitle}
        </Button>
      )}

      {modalOpen && (
        <div className="newsletter-signup__overlay">
          <div className="newsletter-signup__modal">
            <SignupForm
              productBriefing={productBriefing}
              productBusinessNews={productBusinessNews}
              productDeepDive={productDeepDive}
              productEvents={productEvents}
              productMarketing={productMarketing}
              productPodcast={productPodcast}
              toastCaption={toastCaption}
              title={title}
              embedded={false}
              closeModal={() => setModalOpen(false)}>
              {children}
            </SignupForm>
          </div>
        </div>
      )}
    </>
  );
};

NewsletterSignup.propTypes = {
  productBriefing: PropTypes.bool,
  productBusinessNews: PropTypes.bool,
  productDeepDive: PropTypes.bool,
  productEvents: PropTypes.bool,
  productMarketing: PropTypes.bool,
  productPodcast: PropTypes.bool,
  embed: PropTypes.string,
  title: PropTypes.string.isRequired,
  toastCaption: PropTypes.string,
  salesForceCampaignId: PropTypes.string,
  buttonTitle: PropTypes.string.isRequired,
  buttonType: PropTypes.string,
  children: PropTypes.node.isRequired
};

NewsletterSignup.defaultProps = {
  productBriefing: false,
  productBusinessNews: false,
  productDeepDive: false,
  productEvents: false,
  productMarketing: false,
  productPodcast: false,
  embed: '',
  toastCaption: 'Newsletter subscription sent successfully',
  salesForceCampaignId: '',
  buttonType: 'regular'
};

export default NewsletterSignup;
